import { render, staticRenderFns } from "./DashboardDetailsService.vue?vue&type=template&id=498842e0"
import script from "./DashboardDetailsService.vue?vue&type=script&lang=js"
export * from "./DashboardDetailsService.vue?vue&type=script&lang=js"
import style0 from "./DashboardDetailsService.vue?vue&type=style&index=0&id=498842e0&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('498842e0')) {
      api.createRecord('498842e0', component.options)
    } else {
      api.reload('498842e0', component.options)
    }
    module.hot.accept("./DashboardDetailsService.vue?vue&type=template&id=498842e0", function () {
      api.rerender('498842e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DashboardDetails/DashboardDetailsService.vue"
export default component.exports